// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"168":"131135ef","474":"5b526b30","597":"feb62c73","760":"d0464f59","951":"fd3b45b0","999":"2abf0576"}[chunkId] + ".css";
};